/* ------------------------------------------------------------------
  File: AppRoutes.jsx
  Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
  Last Modified: 2026-05-10
------------------------------------------------------------------ */

// Purpose:
//   - AppRoutes defines the frontend route tree for the website.
//   - It maps routesConfig paths to their corresponding page components.
//   - Dynamic route patterns should come from routesConfig.

import { Routes, Route } from "react-router-dom";
import { routesConfig } from "../config/routesConfig";

import TestPage from "../../pages/Test/TestPage";
import TestPage2 from "../../pages/Test/TestPage2";

import Home from "../../pages/Home/Home";
import About from "../../pages/About/About";
import Philosophy from "../../pages/About/Philosophy";
import Leadership from "../../pages/About/Leadership";
import Governance from "../../pages/About/Governance";
import HoldingModel from "../../pages/About/HoldingModel";
import OperatingCompanies from "../../pages/About/OperatingCompanies";
import SectorFocus from "../../pages/About/SectorFocus";
import Partnerships from "../../pages/About/Partnerships";
import SustainabilityAndImpact from "../../pages/About/SustainabilityAndImpact";

import Business from "../../pages/Business/Business";
import PortfolioOverview from "../../pages/Business/PortfolioOverview";
import OperatingSectors from "../../pages/Business/OperatingSectors";
import BusinessSectorDetail from "../../pages/Business/BusinessSectorDetail";

import Investors from "../../pages/Investors/Investors";
import InvestorOverview from "../../pages/Investors/InvestorOverview";
import StrategicCapital from "../../pages/Investors/StrategicCapital";
import RiskGovernance from "../../pages/Investors/RiskGovernance";
import ImpactReturns from "../../pages/Investors/ImpactReturns";

import Careers from "../../pages/Careers/Careers";
import OpenPositions from "../../pages/Careers/OpenPositions";
import Apply from "../../pages/Careers/Apply";

import Newsroom from "../../pages/Newsroom/Newsroom";
import NewsroomArticle from "../../pages/Newsroom/NewsroomArticle";
import Insights from "../../pages/Newsroom/Insights";
import PressReleases from "../../pages/Newsroom/PressReleases";
import Events from "../../pages/Newsroom/Events";

import Contact from "../../pages/Contact/Contact";
import Search from "../../pages/Search/SearchResults";
import Sitemap from "../../pages/Sitemap/Sitemap";
import PrivacyPolicy from "../../pages/PrivacyPolicy/PrivacyPolicy";
import TermsOfUse from "../../pages/TermsOfUse/TermsOfUse";
import Cookies from "../../pages/Cookies/Cookies";
import NotFound from "../../pages/NotFound/NotFound";
import CarouselTestPage from "../../pages/Test/CarouselTestPage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/test-page" element={<TestPage />} />
      <Route path="/test-page2" element={<TestPage2 />} />
      <Route path="/test-carousel" element={<CarouselTestPage />} />
      
      <Route path={routesConfig.home} element={<Home />} />

      {/* ------- Begin About Routes ------- */}
      <Route 
        path={routesConfig.about} 
        element={<About />} 
      />

      <Route
        path={routesConfig.aboutLeadership}
        element={<Leadership />}
      />

      <Route
        path={routesConfig.aboutPhilosophy}
        element={<Philosophy />}
      />

      <Route
        path={routesConfig.aboutGovernance}
        element={<Governance />}
      />

      <Route
        path={routesConfig.aboutHoldingModel}
        element={<HoldingModel />}
      />

      <Route
        path={routesConfig.aboutOperatingCompanies}
        element={<OperatingCompanies />}
      />
      
      <Route
        path={routesConfig.aboutSectorFocus}
        element={<SectorFocus />}
      />

      <Route
        path={routesConfig.aboutPartnerships}
        element={<Partnerships />}
      />

      <Route
        path={routesConfig.aboutSustainabilityAndImpact}
        element={<SustainabilityAndImpact />}
      />
      {/* End */}

      {/* ------- Begin Businesses Routes */}
      <Route path={routesConfig.businesses} element={<Business />} />
      <Route
        path={routesConfig.businessesPortfolioOverview}
        element={<PortfolioOverview />}
      />
      <Route
        path={routesConfig.businessesOperatingSectors}
        element={<OperatingSectors />}
      />
      <Route
        path={routesConfig.businessesSector}
        element={<BusinessSectorDetail />}
      />

      <Route path={routesConfig.investors} element={<Investors />} />
      <Route
        path={routesConfig.investorsOverview}
        element={<InvestorOverview />}
      />
      <Route
        path={routesConfig.investorsStrategicCapital}
        element={<StrategicCapital />}
      />
      <Route
        path={routesConfig.investorsRiskGovernance}
        element={<RiskGovernance />}
      />
      <Route
        path={routesConfig.investorsImpactReturns}
        element={<ImpactReturns />}
      />

      <Route path={routesConfig.careers} element={<Careers />} />
      <Route
        path={routesConfig.careersOpenPositions}
        element={<OpenPositions />}
      />
      <Route path={routesConfig.careersApply} element={<Apply />} />

      <Route path={routesConfig.newsroom} element={<Newsroom />} />
      <Route path={routesConfig.newsroomInsights} element={<Insights />} />
      <Route
        path={routesConfig.newsroomPressReleases}
        element={<PressReleases />}
      />
      <Route path={routesConfig.newsroomEvents} element={<Events />} />
      <Route
        path={routesConfig.newsroomArticle}
        element={<NewsroomArticle />}
      />

      <Route path={routesConfig.contact} element={<Contact />} />
      <Route path={routesConfig.search} element={<Search />} />
      <Route path={routesConfig.sitemap} element={<Sitemap />} />
      <Route path={routesConfig.privacyPolicy} element={<PrivacyPolicy />} />
      <Route path={routesConfig.termsOfUse} element={<TermsOfUse />} />
      <Route path={routesConfig.cookies} element={<Cookies />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;